// extracted by mini-css-extract-plugin
export default {"container":"fl-z","freeShip":"gl-z","privacy":"hl-z"};